@if (showDialog) {
  <dx-popup
    [maxWidth]="450"
    [height]="auto"
    [showCloseButton]="true"
    [showTitle]="true"
    [title]="caption"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="showDialog"
    class="popup-height-auto"
    animation="{ show:'duration:400'}">
    <div *dxTemplate="let data of 'content'">
      @if (title) {
        <div class="mb-2 font-size-16">
          {{ title }}
        </div>
      }
      <div class="mb-4">
        <dx-text-area #textAreaComponent [height]="120" [(value)]="value"></dx-text-area>
      </div>
      <div class="text-center">
        <dx-button class="btn me-2" icon="mdi mdi-content-save" text="{{ 'SAVE' | translate }}" (onClick)="onConfirm()"></dx-button>
        <dx-button class="btn btn-light ms-2" text="{{ 'CLOSE' | translate }}" (onClick)="onCancel()"></dx-button>
      </div>
    </div>
  </dx-popup>
}
